import { gql } from '@apollo/client';

import { FACILITY_FRAGMENT } from '../fragments';

export const GET_FACILITIES = gql`
  query GetFacilities {
    facilities {
      id
      name
      city
      country
      type
      level
    }
  }
`;

export const GET_FACILITIES_BY_COMPANY_ID = gql`
  ${FACILITY_FRAGMENT}
  query GetFacilitiesByCompanyId($companyId: ID!) {
    facilitiesByCompanyId(companyId: $companyId) {
      ...facilityValues
    }
  }
`;
